<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Trình chiếu</strong>
          </div>
          <br />
          <b-grid
            :searchForm="searchForm"
            :gridOptions="gridOptions"
            selectable
            dataUrl="system/sliders"
            gridName="Danh sách trình chiếu"
            ref="userTable"
          >
            <template v-slot:actions>
              <router-link
                to="/system/sliders/create"
                tag="button"
                class="btn btn-primary"
                size="md"
              >
                <i class="fa fa-plus"></i>
              </router-link>
              <b-button size="md" @click.stop="deletes" variant="danger">
                <i class="fa fa-trash-o" aria-hidden="true"></i>
              </b-button>
            </template>
            <template v-slot:cell(urlImage)="row">
              <b-button
                v-if="row.item.sliderType === '1' || row.item.sliderType === 1"
                size="sm"
                v-b-modal.modalPopover
                @click.stop="showImage(row.item, row.index, $event.target)"
                title="Xem ảnh"
              >
                <i class="fa fa-eye" aria-hidden="true"></i>
              </b-button>
              <p v-else>{{ row.item.urlImage }}</p>
            </template>

            <template v-slot:cell(urlThumbnailVideo)="row">
              <b-button v-if="row.item.urlThumbnailVideo"
                size="sm"
                v-b-modal.modalPopover
                @click.stop="showImage2(row.item, row.index, $event.target)"
                title="Xem ảnh"
              >
                <i class="fa fa-eye" aria-hidden="true"></i>
              </b-button>
            </template>
            <template v-slot:cell(_actions)="row">
              <b-button-group>
                <b-button
                  v-if="authorize(['ViewSlider'])"
                  size="sm"
                  :to="{ path: `./detail/${row.item.id}` }"
                  title="xem"
                >
                  <i class="fa fa-eye"></i>
                </b-button>
                <template>
                  <b-button
                    v-if="authorize(['ManageSlider'])"
                    size="sm"
                    :to="{ path: `./edit/${row.item.id}` }"
                    title="sửa"
                  >
                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </b-button>
                  <b-button
                    v-if="authorize(['ManageSlider'])"
                    size="sm"
                    @click.stop="remove(row.item, row.index, $event.target)"
                    class="mr-1"
                    title="xóa"
                  >
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                  </b-button>
                </template>
              </b-button-group>
            </template>
          </b-grid>
        </b-card>
      </b-col>
    </b-row>
    <b-modal id="modalPopover" title="Modal with Popover" ok-only>
      <b-img center :src="urlImage2" alt="image" style="width: 100%"></b-img>
    </b-modal>
  </div>
</template>
<script>
import { authorizationMixin } from "@/shared/mixins";

export default {
  name: "ListSliders",
  mixins: [authorizationMixin],
  data() {
    return {
      searchForm: {},
      gridOptions: {
        fields: [
          {
            key: "sliderTypeName",
            label: "Kiểu",
            sortable: true,
            sortDirection: "asc",
          },
          {
            key: "urlImage",
            label: "Đường dẫn hình ảnh",
            sortable: true,
            sortDirection: "asc",
          },
          {
            key: "urlThumbnailVideo",
            label: "Thumbnail",
            sortable: true,
            sortDirection: "asc",
          },
          { key: "sliderVideoTypeName", label: "Danh mục slider", sortable: false },

          { key: "title", label: "Tiêu đề", sortable: true },
          { key: "displayOrder", label: "Thứ tự hiển thị", sortable: true },
          //{ key: "description", label: "Mô tả", sortable: true },
          //{ key: "link", label: "Đường dẫn", sortable: true },
          //{ key: "labelButton", label: "Tiêu đề nút ấn", sortable: false },
        ],
        sortBy: "displayOrder",
      },
      urlImage2: null,
      urlImage3: null,
    };
  },
  created() {
    var vm = this;
  },
  methods: {
    search() {
      this.$refs.userTable.refresh();
    },
    remove(item, index, button) {
      var vm = this;
      if (confirm("Bạn có chắc chắn muốn xóa bản ghi này?")) {
        this.$services.delete(`system/sliders/${item.id}`).done(() => {
          vm.$toastr.s("Xóa bản ghi thành công");
          vm.search();
        });
      }
    },
    deletes() {
      var vm = this;
      var selectedRows = this.$refs.userTable.selectedRows;
      if (selectedRows.length > 0) {
        if (confirm("Bạn có chắc chắn muốn xóa các bản ghi này?")) {
          var data = selectedRows.map((x) => x.id).join(",");
          this.$services.delete(`system/sliders?ids=${data}`).done(() => {
            vm.$toastr.s("Xóa bản ghi thành công");
            vm.search();
          });
        }
      } else {
        vm.$toastr.e("Vui lòng chọn người dùng cần xóa");
      }
    },
    showImage(item, index, button) {
      console.log(item);
      
      this.urlImage2 = this.$services.getResourceUrl() + item.urlImage;
    },
    showImage2(item, index, button) {
      console.log(item);
      this.urlImage2 = this.$services.getResourceUrl() + item.urlThumbnailVideo;
    },
    getUrlImage(path) {
      return this.$services.getResourceUrl() + path;
    },
  },
};
</script>
<style scoped>
</style>
